import styled from '../../theme/styled-with-theme';
import { mediaQueries } from '../../styles/media-queries';
import { pxToRem } from '../../styles/utils';

import { SpacingToken } from '../../theme/tokens/spacing';
import { BlockContainer } from '../Layout';
import { UnstyledButton } from '../Button';

export const VideoWrapper = styled('div')`
  display: grid;
  width: 100%;
  position: relative;

  ${mediaQueries[0]} {
    height: ${pxToRem(300)};
  }

  ${mediaQueries.min} {
    height: ${pxToRem(300)};
  }

  ${mediaQueries.desktop} {
    height: ${pxToRem(575)};
  }
`;

export const VideoBlockContainer = styled(BlockContainer)<{ hidden?: boolean }>`
  ${({ hidden }) => hidden && 'display: none;'}
`;

export const VideoButton = styled(UnstyledButton)`
  z-index: 1;
  outline: 0;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .playIconBackground,
  .playIconCenter {
    transition: 0.2s fill ease;
  }

  &:hover .playIconBackground,
  &:focus .playIconBackground {
    fill: ${({ theme }) => theme.color.playIconCenter};
  }

  &:hover .playIconCenter,
  &:focus .playIconCenter {
    fill: ${({ theme }) => theme.color.playIconBackground};
  }
`;

export const PlayIcon = styled('svg')`
  cursor: pointer;
  height: 40%;
  width: 100%;
  max-width: 100%;
`;

export const CenteredPlayIcon = styled('svg')`
  cursor: pointer;
  max-width: 100%;
`;

export const LeftBottomPlayIcon = styled('svg')`
  cursor: pointer;
  max-width: 100%;
  position: absolute;

  ${mediaQueries[0]} {
    left: ${pxToRem(48)};
    bottom: ${pxToRem(48)};
  }

  ${mediaQueries.min} {
    left: ${pxToRem(48)};
    bottom: ${pxToRem(48)};
  }

  ${mediaQueries.mobile} {
    left: ${pxToRem(48)};
    bottom: ${pxToRem(48)};
  }

  ${mediaQueries.tablet} {
    left: ${pxToRem(48)};
    bottom: ${pxToRem(48)};
  }

  ${mediaQueries.desktop} {
    left: ${pxToRem(81)};
    bottom: ${pxToRem(82)};
  }
`;

export const CloseIconPositioner = styled('div')`
  cursor: pointer;
  text-align: right;
  position: absolute;
  top: 0;
  right: 0;
  padding: ${({ theme }) => theme.spacing.m};
`;

export const Iframe = styled('iframe')`
  border: 0;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
`;

const IFRAME_PADDING_X: SpacingToken = 'sm';
const IFRAME_PADDING_X_TABLET: SpacingToken = 'xl';
const IFRAME_MAX_HEIGHT = '80vh';
const VIDEO_ASPECT_RATIO = 0.5625;

export const IframeWrapper = styled('div')`
  position: relative;
  overflow: hidden;
  padding-top: ${VIDEO_ASPECT_RATIO * 100}%;
`;

export const IframePositioner = styled('div')`
  max-width: calc(
    ${IFRAME_MAX_HEIGHT} / ${VIDEO_ASPECT_RATIO} -
      (${({ theme }) => theme.spacing[IFRAME_PADDING_X]} * 2)
  );
  max-height: ${IFRAME_MAX_HEIGHT};
  position: absolute;
  width: calc(100% - (2 * ${({ theme }) => theme.spacing[IFRAME_PADDING_X]}));
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  ${mediaQueries.tablet} {
    max-width: calc(
      ${IFRAME_MAX_HEIGHT} / ${VIDEO_ASPECT_RATIO} -
        (${({ theme }) => theme.spacing[IFRAME_PADDING_X_TABLET]} * 2)
    );
    width: calc(
      100% - (2 * ${({ theme }) => theme.spacing[IFRAME_PADDING_X_TABLET]})
    );
  }
`;
